export const Footer = () => {
  return (
    <div className='footer'>
      <div className='container'>
        <div className='footer_text'>2023 | Glass Moon</div>
      </div>
    </div>
  )
}